import { BASE_URL } from "../service/apiConfig"

export const linkForgotPassword = () => {
    return `${BASE_URL}/api/token/requestResetPassword`
}